import React from "react";
import {CallSplitOutlined} from "@mui/icons-material";
import type {PtTier} from "../paymentTermsUtils.ts";
import {gapColor, TIER_LABEL, tierColors} from "../paymentTermsUtils.ts";
import {formatTableMoney} from "../paymentTermsDisplay.ts";
import type {PtSupplier} from "~/experiments/pages/payment-terms/PaymentTermsClasses.ts";

export const TierPill: React.FC<{tier: PtTier}> = ({tier}) => {
    const {bg, fg} = tierColors(tier);
    return <span className="pt-priority-pill" style={{backgroundColor: bg, color: fg}}>{TIER_LABEL[tier]}</span>;
};

export const ReviewChip: React.FC<{excluded: boolean; reason?: string}> = ({excluded, reason}) => (
    excluded
        ? <span className="pt-review-chip pt-review-excluded" title={reason}>Excluded</span>
        : <span className="pt-review-chip pt-review-potential">Potential</span>
);

/** Count of distinct payment terms, flagged when the supplier has more than one. */
export const TermCountCell: React.FC<{row: PtSupplier}> = ({row}) => (
    <span className={`pt-termcount${row.multipleTerms ? ' is-multi' : ''}`}>
        {row.multipleTerms && <CallSplitOutlined fontSize="inherit"/>}
        {row.distinctTermCount}
    </span>
);

/**
 * Current-vs-target term as a small horizontal gauge.
 * The filled part shows the current weighted term relative to the policy target.
 */
export const TermGaugeCell: React.FC<{row: PtSupplier}> = ({row}) => {
    const pct = Math.max(0, Math.min(1, row.currentTerm / Math.max(1, row.targetTerm)));
    const color = gapColor(row.gapDays);
    return (
        <span className="pt-term-gauge">
            <span className="pt-term-gauge-value" style={{color}}>{row.currentTerm.toFixed(0)}d</span>
            <span className="pt-term-gauge-track">
                <span className="pt-term-gauge-fill" style={{width: `${pct * 100}%`, backgroundColor: color}}/>
            </span>
            <span className="pt-term-gauge-target">{row.targetTerm.toFixed(0)}d</span>
        </span>
    );
};

export const WcOpportunityCell: React.FC<{value: number; currency: string | null; excluded?: boolean}> = ({value, currency, excluded}) => (
    <span className={`pt-wc-cell${excluded ? ' is-excluded' : ''}`}>{formatTableMoney(value, currency)}</span>
);
